<template>
  <div class="d-flex justify-center">
    <div style="width: 700px; max-width: 700px">
      <faqs
        :faqs="faqs"
        :active-tab="activeTab"
        :available-languages="availableLanguages"
        :show-faqs-usage="showFaqsUsage"
      />
    </div>
  </div>
</template>

<script>
import Faqs from '@/components/faq/Faqs';
import Layout from '@/components/shared/TheLayout';

export default {
  components: {
    Faqs
  },

  layout: (h, page) => h(Layout, {
    props: {
      pageTitle: page.data.props.pageTitle
    }
  }, [page]),

  props: {
    faqs: {
      type: Array,
      required: false,
      default: () => []
    },
    activeTab: {
      type: String,
      required: true,
      validator: function(value) {
        return ['create', 'index'].indexOf(value) !== -1;
      }
    },
    pageTitle: {
      type: String,
      required: true
    },
    numFaqs: {
      type: Number,
      required: true
    },
    availableLanguages: {
      type: Array,
      required: false,
      default: () => []
    },
    showFaqsUsage: {
      type: Boolean
    }
  },

  data() {
    return {
      tab: this.activeTab,
    }
  }
}
</script>